import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { appModernizationDetails } from '../../../../../config';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';
import moment from 'moment';
import { SharedAuthService } from '../../../../../shared/shared.auth.service';
import { CommonService } from './common.service';
import { BULK_MAINTENANCE_ERROR_MESSAGES } from './bulk-maintenance-error-messages';

@Injectable({
    providedIn: 'root'
})
export class InitiativeService {
    editableColumns: string[] = [];
    editableColumnDetails: any[] = [];
    uploadedData: any[] = [];
    workingData: any[] = [];
    initiationMaster: any;
    isFullAccess: string = 'No';
    allColumns: any[] = [];
    primaryColumn: any;
    lobColumn: any;
    subLobColumn: any;
    userDtls: any;

    private apiUrl: string;
    private config: any;
    private isAdmin: string = 'false';
    private allUserRoles: any;
    private largeUrl: string;
    constructor(private http: HttpClient,private sharedAuthService: SharedAuthService, private commonService: CommonService) {
        this.config = appModernizationDetails;
        this.apiUrl = environment.apiUrl;
        this.largeUrl = environment.LargeapiUrl;
        const currentUser = sessionStorage.getItem('currentUser') || '';
        this.userDtls = {
            cn: this.sharedAuthService.getMsid(),
            mail: sessionStorage.getItem('loggedInUserEmail') || '',
            givenName: currentUser ? currentUser.trim().split(',')[1].trim() : '',
            sn: currentUser ? currentUser.trim().split(',')[0].trim() : '',
        }
    }

    public initiativeColumndetails(id): Observable<any> {
        const url = this.apiUrl + this.config.routerpath.initiativeColumnDetails + '/' + id;
        const headers = new HttpHeaders({
          'Content-Type': ''
        });
        const options = {
          headers: headers
        }
        return this.http.get<any>(url, options);
    }

    public initiativePreview(body: any): Observable<any> {
        const url = this.largeUrl + this.config.routerpath.initiativePreview;
        body['userDetails'] = this.userDtls;
        if (environment.environmentName == 'uat') body['instance'] = environment.environmentName;
        const headers = new HttpHeaders({
          'Content-Type': ''
        });
        const options = {
          headers: headers
        }
        return this.http.put<any>(url, body, options);
    }

    public initiativeSubmit(body: any): Observable<any> {
        const url = this.largeUrl + this.config.routerpath.initiativeSubmit;
        body['userDetails'] = this.userDtls;
        if (environment.environmentName == 'uat') body['instance'] = environment.environmentName;
        const headers = new HttpHeaders({
          'Content-Type': ''
        });
        const options = {
          headers: headers
        }
        return this.http.put<any>(url, body, options);
    }


    public identifyEditbaleColumns (columnDetails: any[]) {
        this.editableColumnDetails = [];
        this.editableColumns = [];
        this.allColumns = columnDetails;
        columnDetails.forEach(item => {
            if (item['Bulk_required'] == 'Yes' && item['Editable'] == 'Yes') {
                this.editableColumns.push(item['column_name']);
                this.editableColumnDetails.push(item);
            }
        });
    }

    public checkInitiationFullAccess () {
        const accessRoles = this.initiationMaster['Full_Access_Role'].split(',');
        for (const key of Object.keys(this.allUserRoles)) {
            if(key == 'Admin' && this.isAdmin == 'true' && accessRoles.includes(key)) {
                this.isFullAccess = 'Yes';
                break;
            }
            else if (accessRoles.includes(key) && key != 'Admin') {
                this.isFullAccess = 'Yes';
                break;
            }
        }
    }

    public modifyUploadedData (data: any[], columnDetails: any[]) {
        const dataset = [];
        const multi_dropdown_cols = [];
        const date_columns = [];
        columnDetails.forEach(item => {
            if (item['input_type'] == 'multi_dropdown') {
                multi_dropdown_cols.push(item['column_name']);
            }
            if (item['input_type'] == 'date picker') {
                date_columns.push(item['column_name']);
            }
        });
        for (const [index, item] of data.entries()) {
            item['rowNum'] = index;
            item['Status'] = 'Success';
            item['Message'] = '';
            Object.keys(item).forEach(key => {
                if(multi_dropdown_cols.includes(key)) {
                    let arr = item[key].split(',');
                    arr = arr.map((item) => item.trim());
                    item[key] = arr.join(',');
                } else if (date_columns.includes(key) && item[key]) {
                    item[key] = item[key].trim();
                    if (moment(item[key], 'M/D/YYYY', true).isValid() || moment(item[key], 'M/D/YY', true).isValid() 
                        || moment(item[key], 'MM/DD/YYYY', true).isValid() || moment(item[key], 'MM/DD/YY', true).isValid()) {
                        const date = moment(item[key]).format('M/D/YYYY').toString();
                        item[key] = date;
                    } else {
                        item[key] = item[key].toString().trim();
                    }
                } else item[key] = item[key].toString().trim();
            });
            dataset.push(item);
        }
        return dataset;
    }

    public modifyWorkingData (data: any[]) {
        this.uploadedData = data;
        const workingData = [];
        for (const item of this.uploadedData) {
            const obj = {
                rowNum: item['rowNum'],
                app_id: item[this.primaryColumn['column_name']],
                lob_id: item[this.lobColumn['column_name']],
                sublob_id: item[this.subLobColumn['column_name']]
            };
            for (const key of Object.keys(item)) {
                if (this.editableColumns.includes(key)) {
                    obj[key] = item[key];
                }
            }
            workingData.push(obj);
        }
        this.workingData = workingData;
    }

    public initializeUserData () {
        this.isAdmin = this.sharedAuthService.checkAdminSGAccess() ? 'true' : 'false';
        const AppEditor_AllRoles = this.sharedAuthService.getAppEditorAllRoles();
        this.allUserRoles = AppEditor_AllRoles;
    }

    public validateInitiative (data: any[], columnDetails: any[], initiationMaster: any, requiredColumns: any[]) {
        let errorRecords = [];
        this.identifyEditbaleColumns(columnDetails);
        this.primaryColumn = this.allColumns.find((data) => data['column_id'] == 'G1');
        this.lobColumn = this.allColumns.find((data) => data['column_id'] == 'G5');
        this.subLobColumn = this.allColumns.find((data) => data['column_id'] == 'G7');
        
        this.initiationMaster = initiationMaster;
        this.initializeUserData();
        this.checkInitiationFullAccess();
        this.modifyUploadedData(data, columnDetails);
        const uniqueKeys = [...this.editableColumns, this.primaryColumn['column_name']];
        const { uniques, duplicates } = this.commonService.findDuplicatesAndUniqueRecords(data, uniqueKeys); 
        const {validColumnData, invalidColumnData}  = this.checkUpdateType(uniques, requiredColumns); // { no_update_type, validColumnData }

        this.modifyWorkingData(validColumnData);
       
        
        const reqBody = { 
            uniques:validColumnData, 
            // duplicates, 
            // no_update_type,
            editableColumns: this.editableColumns,
            editableColumnDetails: this.editableColumnDetails,
            isFullAccess: this.isFullAccess,
            primaryColumn: this.primaryColumn,
            lobColumn: this.lobColumn,
            subLobColumn: this.subLobColumn,
        };
        errorRecords = [...invalidColumnData, ...duplicates];
        return { reqBody, errorRecords };
    }

    public checkUpdateType (columnDetails: any[], requiredColumns: any[]) {
        const validColumnData = [], invalidColumnData = [];
         let requiredFields = [];
        const fieldValidations = [
            { key: 'Update_Type(U)', message: BULK_MAINTENANCE_ERROR_MESSAGES.INITIATIVE.UPDATE_TYPE_REQUIRED, checks: ['nullCheck'] },
            { key: 'Update_Type(U)', message: BULK_MAINTENANCE_ERROR_MESSAGES.INITIATIVE.UPDATE_TYPE_INVALID, checks: ['validCheck'] },
            { key: 'Application ID', message: BULK_MAINTENANCE_ERROR_MESSAGES.INITIATIVE.APPLICATION_ID_INVALID, checks: ['nullCheck'] }
        ];

        requiredFields = fieldValidations
            .filter(validation => requiredColumns.includes(validation.key))
            .flatMap(validation => 
            validation.checks.map(check => ({
                key: validation.key,
                message: validation.message,
                [check]: true
            }))
            );
        console.log('Required Fields:', requiredFields);
        for (const [index, item] of columnDetails.entries()) {
             let obj = this.commonService.initializeValidationObject();
             obj = this.commonService.validateFieldsAndUpdateType(requiredFields, item, index, obj, ['U']);

            if (obj.status === false) {
                item['Status'] = 'Fail';
                item['Message'] = obj.message;
                invalidColumnData.push(item);
            } else {
                item['Status'] = 'Success';
                item['Message'] = '';
                validColumnData.push(item);
            }
           
        }
        return { validColumnData, invalidColumnData };
    }


}